export const API_KEY = `e41b3457918a8ae7ca19a80664eececd`; // Fill this in with your own API key from https://scripture.api.bible/
;
